module.exports = __webpack_public_path__ + "media/images/pear-map-0a1506c7b919c9af0d0159beecb7635b.png";